import { render } from "./AccountPageUpdate.vue?vue&type=template&id=ccbac83e&scoped=true"
import script from "./AccountPageUpdate.vue?vue&type=script&lang=js"
export * from "./AccountPageUpdate.vue?vue&type=script&lang=js"

import "./AccountPageUpdate.vue?vue&type=style&index=0&id=ccbac83e&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\php\\POS-SYSTEM-BACKUP-STRIPE\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ccbac83e"]])

export default __exports__